export default "__VITE_ASSET__m6ILmg3N__"